import gql from "graphql-tag";

export const GET_CUSTOMER = gql`
  query customer($customerId:String!) { 
    customer(customerId: $customerId) {
      customerId
      name
      email
      phone
      memberSince
      status
      tacAccepted
      tacVersion
      tags
      marketingAccepted
      authProvisioned
      authInvited
      referralCode
      subsActive
      subsCancelled
      subsPaused
      type
      referralOnboardingPromoType
      referralOnboardingPromoId
    }
  }
`;

export const GET_ACCOUNT_HOLDER = gql`
  query accountHolder($accountId:String!) { 
    accountHolder(accountId: $accountId) {
      customerId
      name
      email
      phone
      memberSince
      status
      tacAccepted
      tacVersion
      marketingAccepted
      authProvisioned
      authInvited
      referralCode
      subsActive
      subsCancelled
      subsPaused
      referralOnboardingPromoType
      referralOnboardingPromoId
    }
  }
`

export const GET_ACCOUNT = gql`
  query account($accountId:ID!) {
    account(accountId:$accountId) {
      accountId
      customerId
      name
      deleted
    }
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query billingPaymentMethods($accountId:ID!) {
    billingPaymentMethods(accountId:$accountId) {
      paymentMethodId
      type
      cardBrand
      cardExpYear
      cardExpMonth
      cardLast4
      default
      addedAt
    }
  }
`;

export const GET_CHARGES = gql`
  query billingCharges($accountId:ID!) {
    billingCharges(accountId:$accountId) {
      salesOrderId
      kind
      amount
      currency
      status
      paymentTermsDays
      dueAt
      createdAt
      updatedAt
    }
  }
`;

export const GET_CHARGE_PAYMENTS = gql`
  query billingChargePayments($accountId:ID!, $salesOrderId:ID!) {
    billingChargePayments(accountId:$accountId, salesOrderId:$salesOrderId) {
      salesOrderId
      eventName
      paymentMethod
      paymentMethodId
      paymentIntentId
      cardBrand
      cardLast4
      type
      countryCode
      bankName
      amount
      currency
      errorCode
      successful
      transactionRef
      createdAt
    }
  }
`;

export const GET_SHIPPING_COUNTRIES_FOR_ACCOUNT = gql`
  query availableCountriesForAccount($accountId:ID!) {
    availableCountriesForAccount(accountId:$accountId) {
      kind
      code
      name
      availability
    }
  }
`;

export const GET_SHIPPING_ADDRESS_FOR_EDIT = gql`
  query getShippingAddressForEdit($accountId:ID!,$addressId:ID!) {
    availableCountriesForAccount(accountId:$accountId) {
      kind
      code
      name
      availability
    }
    shippingAddress(accountId:$accountId,addressId:$addressId) {
      accountId
      addressId
      type
      name
      addressAddressLine1
      addressAddressLine2
      addressCity
      addressStateProvince
      addressPostcode
      addressCountryCode
      addressCountryName
    }    
  }    
`;

export const GET_ACCOUNT_WITH_BILLING = gql`
  query account($accountId:ID!) {
    account(accountId:$accountId) {
      accountId
      customerId
      name
      subsActive
      subsCancelled
      subsPaused      
      vip
    }
    billingAccount(accountId: $accountId) {
      accountId
      address {
        name
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressStateProvince
        addressPostcode
        addressCountryCode
        addressCountryName
      }
      addressStatus
      stripeId
      paymentMethod
      paymentTermsDays
      currency
      shopId
      type
      taxId
      validTaxId
      taxExempt
      taxExemptionDescription
      status
    }
    cart(accountId: $accountId) {
      accountId
      subscriptionsPolicy
      productOrdersPolicy
      waterOrdersPolicy
      subscriberPricelist
      subscriptionPricelistVersion
      productPricelistVersion
    }
    salesAccountPurchases(accountId: $accountId) {
      accountId
      products {
        productSku
        quantity
      }
    }
  }
`;

export const ON_BILLING_UPDATED = gql`
  subscription onBillingUpdated($accountId: ID!) {
    updatedBilling(accountId: $accountId) {
      accountId
    }
  }
`;

export const ON_UPDATED_CART = gql`
  subscription onUpdatedCart($accountId: ID!) {
    updatedCart(accountId: $accountId) {
      accountId
    }
  }
`;


export const GET_BILLING_ADDRESS = gql`
  query billingAddress($accountId:ID!) {
    billingAddress(accountId:$accountId) {
      accountId
      name
      addressLine1
      addressLine2
      city
      stateProvince
      postcode
      countryCode
      countryName
      status
    }
  }
`;

export const LIST_CUSTOMERS = gql`
  { customers { 
    customerId
    name
    email
    referralCode
    authInvited
    authProvisioned
    subsActive
    subsCancelled
    subsPaused
  }}
`;

export const LIST_CUSTOMERS_WITH_FILTERS = gql`
  query customers($filter: CustomerFilters, $pagination:PaginationInput) {
    customers(filter: $filter, pagination: $pagination) {
      entries {
        customerId
        name
        email
        referralCode
        authInvited
        authProvisioned
        subsActive
        subsCancelled
        subsPaused
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

export const LIST_CUSTOMER_ACCOUNTS = gql`
  query($customerId:ID!) {
    accountsForCustomer(customerId:$customerId) {
      accountId
      customerId
      name
      vip
      deleted
    }
  }
`;

export const ON_CUSTOMER_UPDATED = gql`
  subscription onCustomerUpdated($customerId: ID!) {
    updatedCustomer(customerId: $customerId) {
      customerId
    }
  }
`;


export const ON_CUSTOMER_ACCOUNTS_UPDATED = gql`
  subscription onCustomerAccountsUpdated($customerId: ID!) {
    updatedCustomerAccounts(customerId: $customerId) {
      customerId
    }
  }
`;

export const ON_NEW_CUSTOMER = gql`
  subscription {
    newCustomer { 
      customerId
      name
      email
      referralCode,
      authInvited
      authProvisioned    
      subsActive
      subsCancelled  
      subsPaused
    }
  }
`;

export const ACCOUNT_ACCESS = gql`
  query accountAccess($accountId:ID!) {
    accountAccess(accountId:$accountId) {
      accountId
      customers {
        customerId
        email
        name
        roles
      }
    }
  }
`;

export const ACCOUNT_SUBSCRIPTIONS = gql`
  query accountSubscriptions($accountId: String!) {
    accountSubscriptions(accountId:$accountId) {
      accountId
      subscriptionId
      name
      frequencyWeeks
      status     
      hasEstimatedDeliveryDate
      nextEstimatedDeliveryDate 
      products {
        productSku
        productTitle
        quantity
        unitPrice
        currency
        total
      }
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressStateProvince
        addressPostcode
        addressCountryName
        addressCountryCode
      }
      shippingAddressSurcharges {
        productSku
        surcharge {
          currency
          value
        }
      }      
    }
  }
`;